import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { logger } from '../utils/logger';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // This page should not receive OAuth callbacks anymore
    // Turing Server handles everything and redirects to /
    logger.warn('⚠️ AuthCallback page accessed - this should not happen with new OAuth flow');

    // Redirect to login since we shouldn't be here
    navigate('/login');
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080c14]">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-blue-100 bg-blue-900">
            <RefreshCw className="h-10 w-10 text-blue-400 animate-spin" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-white">
            Redirecting...
          </h2>
          <p className="mt-2 text-sm text-slate-400">
            Please wait while we redirect you.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;